// GCP hanggukeo-dev 환경

export const environment = {
  production: false,
  apiUrl: 'https://han-dev-api.listenandlearnkorean.com',
  naverClientId: "kKYTXuJfatGHYp9FV3M4",
  naverCallbackUrl: "https://han-dev-www.listenandlearnkorean.com/callback/naver",
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
